import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="upload-button"
export default class extends Controller {
  static targets = ["uploadInDatabase", "input", "filename", "error"];

  connect() {
    if (this.hasUploadInDatabaseTarget) {
      this.uploadInDatabaseTarget.classList.add(
        "max-h-96",
        "overflow-hidden",
        "motion-safe:transition-all",
      );
    }
  }

  handleChange() {
    this.errorTarget.innerText = "";

    if (this.inputTarget.files.length > 0) {
      const file = this.inputTarget.files[0];

      this.filenameTarget.innerHTML = file.name;

      if (this.hasUploadInDatabaseTarget) {
        this.uploadInDatabaseTarget.classList.replace("max-h-96", "max-h-0");
      }

      if ("createImageBitmap" in window) {
        createImageBitmap(file).then(
          ({ width, height }) => {
            if (width < height) {
              this.errorTarget.innerText = `This image is in portrait orientation (${width}×${height}px), please provide a landscape image where possible.`;
            }
          },
          (reason) =>
            console.error("Could not create bitmap from image file", reason),
        );
      }
    }
  }

  error(event) {
    event.preventDefault();
    alert(
      "Your file could not be uploaded, please try again with a PNG or JPEG that is under 1MB in size.",
    );
  }
}
